module.exports = __webpack_public_path__ + "img/shopping-cart.2739866e.svg";